import React from "react";
import SuggestionCallout from "./SuggestionCallout";
import {
    formatCLP,
    formatCLPAbs,
    savingsIsPositive,
} from "../utils/format";

const versionLabel = (v) => `${v.model_name} ${v.version_name}`.trim();

const getSavings = (entry) =>
    entry && entry.result ? parseFloat(entry.result.annual_savings_clp) : null;

// Fila del encuadre neutro: nombre y propulsión, diferencia anual y el detalle
// de ambos gastos.
const NeutralRow = ({ version, entry }) => {
    const savings = getSavings(entry);
    const positive = savings != null && savingsIsPositive(savings);
    const result = entry && entry.result;

    let value = "—";
    if (entry && entry.loading && savings == null) {
        value = "…";
    } else if (savings != null) {
        // El verde con "+" se reserva para el ahorro; la diferencia en contra va
        // sin signo y en tinta normal.
        value = positive
            ? formatCLP(savings, { withSign: true })
            : formatCLPAbs(savings);
    }

    return (
        <li className="savings-calculator__compare-row">
            <div className="savings-calculator__compare-head">
                <span className="savings-calculator__compare-name">
                    {versionLabel(version)}
                    <span className="savings-calculator__compare-sub">
                        {version.motor || ""}
                    </span>
                </span>
                <span
                    className={
                        "savings-calculator__compare-value" +
                        (savings == null ? "" : positive ? " is-positive" : " is-neutral")
                    }
                >
                    {value}
                    <span className="savings-calculator__compare-per">/año</span>
                </span>
            </div>

            {result ? (
                <p className="savings-calculator__compare-detail">
                    Gasto vehículo actual:{" "}
                    <strong>{formatCLP(result.annual_cost_current_clp)}/año</strong> ·
                    Gasto {version.model_name}:{" "}
                    <strong>{formatCLP(result.annual_cost_toyota_clp)}/año</strong>
                </p>
            ) : null}
        </li>
    );
};

// Fila del encuadre positivo: la lista escueta de siempre, en verde.
const PositiveRow = ({ version, entry }) => {
    const savings = getSavings(entry);
    const loading = entry && entry.loading && savings == null;

    return (
        <li className="savings-calculator__compare-row savings-calculator__compare-row--plain">
            <span className="savings-calculator__compare-name">
                {versionLabel(version)}
            </span>
            <span
                className={
                    "savings-calculator__compare-value" +
                    (savings != null ? " is-positive" : "")
                }
            >
                {loading ? "…" : savings != null ? formatCLP(savings, { withSign: true }) : "—"}
            </span>
        </li>
    );
};

const ResultCompare = ({ comparison }) => {
    const rows = comparison.filter((item) => item.version);
    // Basta con que un modelo gaste más que el vehículo actual para pasar todo
    // el panel al encuadre neutro: título genérico, detalle por modelo y sugerencia.
    const neutralFraming = rows.some((item) => {
        const savings = getSavings(item.entry);
        return savings != null && !savingsIsPositive(savings);
    });

    const Row = neutralFraming ? NeutralRow : PositiveRow;

    return (
        <div
            className={
                "savings-calculator__result savings-calculator__result--compare" +
                (neutralFraming ? " savings-calculator__result--neutral" : "")
            }
        >
            <p className="savings-calculator__result-eyebrow">
                {neutralFraming
                    ? "Diferencia en gasto de combustible"
                    : "Comparativa de ahorro anual estimado"}
            </p>

            <ul
                className={
                    "savings-calculator__compare-list" +
                    (neutralFraming ? " savings-calculator__compare-list--detailed" : "")
                }
            >
                {rows.map(({ id, version, entry }) => (
                    <Row key={id} version={version} entry={entry} />
                ))}
            </ul>

            <p className="savings-calculator__result-note">
                *Estimado bajo condiciones de manejo eficiente.
            </p>

            {neutralFraming ? <SuggestionCallout /> : null}
        </div>
    );
};

export default ResultCompare;
